import React, { useState, useEffect, useContext } from 'react'
import Card from '../../../../Components/Card/Card';
import { Button } from 'primereact/button';

import { TabPanel, TabView } from 'primereact/tabview';
import { CuentasPorPagarLang } from '../Lang/CuentasPorPagarLang';
import { getLabel } from '../../../../Services/Language/LanguageService';
import ListadoRegistroFacturas from '../TabsRegistroFacturas/ListadoRegistroFacturas';
import DetallesRegistroFacturas from '../TabsRegistroFacturas/DetallesRegistroFacturas';
import { ConfigContext } from '../../../../Context/ConfigContext/ConfigContext';

const RegistroFacturasMateriaPrimaScreen = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { config } = useContext(ConfigContext);
    return (
        <div>
            <TabView className="col-12 homeTabView" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={getLabel(CuentasPorPagarLang, 'TituloMateriaPrima', config?.language)}>
                    <ListadoRegistroFacturas isMateriaPrima = {true} />
                </TabPanel >
                <TabPanel header={getLabel(CuentasPorPagarLang, 'TituloDetalles', config?.language)}>
                    <DetallesRegistroFacturas isMateriaPrima = {true} />
                </TabPanel >

            </TabView>


        </div>
    )
}

export default RegistroFacturasMateriaPrimaScreen